import * as React from 'react';
import { connect } from 'react-redux';

import {
    getStaticText,
} from "../reducers/staticTexts";

import {
    getClientId,
    getBaseUrl
} from '../reducers/config';

import { getTranslations } from "../reducers/translations";

import { getActiveChannelId, getOverlayVisibility } from '../reducers/gui';
import { getTimings, getMatchIds, getMatchIdByChannelId} from '../reducers/timings';

import {
    getServingPlayerIdByMatchId,
    getPlayerNameByPlayerId,
    getPlayerAbbreviationByPlayerId,
    getServingPlayerByMatchId,
    getSetStatus
} from '../reducers/matches';

import {
    getLastServiceGamesWon,
    getLastServicePointsWon,
    getLastTiebreakGamesWon
} from '../reducers/statsPlayerAggregate';

import LiveStatisticBarPresentation from '../presentations/LiveStatisticBar/LiveStatisticBarPresentation';

const mapStateTopProps = (state:any) => {

    // get active channel number as this statistic is only shown for the active channel
    const activeChannelId:number = getActiveChannelId(state);

    // get matchid of active channel
    const activeMatchId:number = getMatchIdByChannelId(state, activeChannelId);

    // get players id
    let playerId:any = getServingPlayerIdByMatchId(state, activeMatchId);

    // get players abbreviated name
    let playerAbbrName:any = getPlayerAbbreviationByPlayerId(state, playerId);

    // TODO
    // this is only a dummy as the player in the recorded feed do not match the real players (ids etc.)
    let isHomeOrAway = getServingPlayerByMatchId(state, activeMatchId);

    const lastServiceGamesWon :any = getLastServiceGamesWon(state, isHomeOrAway, activeChannelId);
    const lastServicePointsWon:any = getLastServicePointsWon(state, isHomeOrAway, activeChannelId);
    const lastTiebreakGamesWon:any = getLastTiebreakGamesWon(state, isHomeOrAway, activeChannelId);

    // returns 1 if set is in tie break or 0 if it isn't
    const isTieBreak:number = getSetStatus(state, activeMatchId);

    return (
    {
        baseUrl: getBaseUrl(state),
        clientid: getClientId(state),
        overlayIsVisible: getOverlayVisibility(state),
        staticTexts: getStaticText(state),
        translations: getTranslations(state),
        player: {
            displayName: playerAbbrName,
            isHomeOrAway: isHomeOrAway,
            playerId: playerId
        },
        serviceGamesWon: {
            //name: 'Service Games Won',
            current: lastServiceGamesWon.value,
            total: lastServiceGamesWon.count
        },
        servicePointsWon: {
            //name: 'Service Points Won (Last 10)',
            current: lastServicePointsWon.value,
            total: lastServicePointsWon.count
        },
        tiebreakGamesWon: {
            //name: 'Tie Breaks Won (Last 10)',
            current: lastTiebreakGamesWon.value,
            total: lastTiebreakGamesWon.count
        },
        isTiebreak: isTieBreak
    }
    );
};

export default connect(mapStateTopProps)(LiveStatisticBarPresentation);
